import { useIdentityContext, useWebSocketContext } from '@flik/shared';
import React, { useEffect } from 'react';
import { useSessions } from '../hooks/useSessions';

const SessionRefreshHandler: React.FC = () => {
  const { onMessageReceived } = useWebSocketContext();
  const { isLoggedIn } = useIdentityContext();
  const { refetch } = useSessions();

  // Register message handler for session invitations to refresh sessions
  useEffect(() => {
    const cleanupInvited = onMessageReceived(
      'onInvitedToSession',
      (message) => {
        console.log(
          'SessionRefreshHandler: Invited to session received, refreshing sessions:',
          message,
        );

        // Only refresh sessions if user is logged in
        if (!isLoggedIn) {
          console.log(
            'SessionRefreshHandler: User not logged in, skipping session refresh',
          );
          return;
        }

        // Trigger a refetch of both active and inactive sessions
        refetch();
      },
    );

    const cleanupRemoved = onMessageReceived(
      'onRemovedFromSession',
      (message) => {
        console.log(
          'SessionRefreshHandler: Removed from session received, refreshing sessions:',
          message,
        );

        // Only refresh sessions if user is logged in
        if (!isLoggedIn) {
          console.log(
            'SessionRefreshHandler: User not logged in, skipping session refresh',
          );
          return;
        }

        // Trigger a refetch of both active and inactive sessions
        refetch();
      },
    );

    const cleanupSessionEnded = onMessageReceived(
      'onSessionEnded',
      (message) => {
        console.log(
          'SessionRefreshHandler: Session ended received, refreshing sessions:',
          message,
        );

        // Only refresh sessions if user is logged in
        if (!isLoggedIn) {
          console.log(
            'SessionRefreshHandler: User not logged in, skipping session refresh',
          );
          return;
        }

        // Trigger a refetch of both active and inactive sessions
        refetch();
      },
    );

    return () => {
      console.log(
        'SessionRefreshHandler: Cleaning up onInvitedToSession, onRemovedFromSession, and onSessionEnded handlers',
      );
      cleanupInvited();
      cleanupRemoved();
      cleanupSessionEnded();
    };
  }, [onMessageReceived, refetch, isLoggedIn]);

  // This component doesn't render anything - it just handles WebSocket messages
  return null;
};

export default SessionRefreshHandler;
